import { Controller } from '@hotwired/stimulus';
import { snakeCase, camelCase } from 'lodash';

export default class extends Controller {
  static values = {
    url: String,
  };

  static targets = [
    'directInvestorsValidatedCount',
    'cgpInvestorsValidatedCount',
  ];

  connect() {
    this.fetchAndFillMetrics();
  }

  fetchAndFillMetrics() {
    const metrics = this.fetchableMetrics();

    if (!metrics?.length > 0) return;

    fetch(this.urlValue, {
      headers: {
        Accept: 'application/json'
      },
    })
      .then(response => response.json())
      .then(data => {
        metrics.forEach((targetName) => {
          const target = this[`${targetName}Target`]
          const key = snakeCase(targetName)

          if (key in data && data[key] != null) {
            target.textContent = data[key]
          }
        })
      })
  }

  fetchableMetrics() {
    return this.constructor.targets.filter((targetName) => {
      return this[`${camelCase('has_' + targetName)}Target`] &&
        this[`${targetName}Target`].dataset.fetchable === 'true'
    })
  }
}
